/**
 * @generated SignedSource<<0e8d63ea22d95a5b8331ff6ede9d3767>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardCover_workManagementBoard_CardCoverInner_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cardCover_workManagementBoard_CardImageCover_queryFragment">;
  readonly " $fragmentType": "cardCover_workManagementBoard_CardCoverInner_queryFragment";
};
export type cardCover_workManagementBoard_CardCoverInner_queryFragment$key = {
  readonly " $data"?: cardCover_workManagementBoard_CardCoverInner_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"cardCover_workManagementBoard_CardCoverInner_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cardCover_workManagementBoard_CardCoverInner_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "cardCover_workManagementBoard_CardImageCover_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "01b522623e1ec272cbbaf4ad3c86b91b";

export default node;
